import { z } from "zod";

import { convertToEnglishNumber, normalizeIranianPhone } from "../../../utils";

export const phoneSchema = z.object({
  phoneNumber: z
    .string()
    .transform((value) => normalizeIranianPhone(value))
    .refine((value) => /^09\d{9}$/.test(value), "شماره همراه معتبر نیست"),
});

export const otpSchema = z.object({
  otp: z
    .string()
    .transform((value) =>
      convertToEnglishNumber(value).replace(/\D/g, "").slice(0, 6)
    )
    .refine((value) => /^\d{6}$/.test(value), "کد تأیید باید ۶ رقم باشد"),
});

export const profileSchema = z.object({
  fullName: z.string().trim().min(2, "نام باید حداقل ۲ کاراکتر باشد"),

  voiceStyle: z.string().min(1, "لطفاً سبک مورد علاقه خود را انتخاب کنید"),
});

export type PhoneForm = z.infer<typeof phoneSchema>;
export type OtpForm = z.infer<typeof otpSchema>;
export type ProfileForm = z.infer<typeof profileSchema>;
